export default [
    {
        path: 'deaths',
        component: () => import('@/pages/isle/record/deaths')
    },
    {
        path: 'chat',
        component: () => import('@/pages/isle/record/chat')
    },
    {
        path: 'ban',
        component: () => import('@/pages/isle/record/ban')
    },
    {
        path: 'quite',
        component: () => import('@/pages/isle/record/quite')
    }
];